import {
  getDaysTillGoalDate,
  getCompactLocalizedDateLabel,
  getBmi,
  getGolaPaceKgValues,
  getGolaPaceLbsValues,
  getFasterProgressDaysDiff,
  getFirstWeekLoss
} from "../../../common/js/helpers"

export default (commonView) =>
  () => ({
    ...commonView(),

    init() {
      this.commonInit()

      const data = { segmentUserId: this.store.values.segmentUserId || "" }
      this.store.internalTracker.isUserIdentified(data).then((isIdentified) => {
        if (!isIdentified) {
          this.store.internalTracker.trackIdentify({
            customData: {
              email: this.store.values.email,
              segmentUserId: this.store.values.segmentUserId,
            },
          })
        }
      })
    },

    // Product requirement for the formula:
    // Math.min(5kg, (currentWeight - targetWeight)/3) + (3 * maxGoalPace)
    calculateWeightLoss(currentWeight, targetWeight, maxGoalPace, firstWeekWeightLoss) {
      const weightDiff = Math.abs(currentWeight - targetWeight)
      const initialLoss = Math.min(firstWeekWeightLoss, weightDiff / 3)
      const firstMonthWeightLoss = Math.round(initialLoss + 3 * maxGoalPace)
      const isExcessWeightRemaining = weightDiff >= firstMonthWeightLoss

      return isExcessWeightRemaining ? firstMonthWeightLoss : weightDiff
    },

    getFirstMonthWeightLoss() {
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values

      const maxGoalPace = this.store.isMetric()
        ? getGolaPaceKgValues().reverse()[0]
        : getGolaPaceLbsValues().reverse()[0]

      return this.store.isMetric()
        ? this.calculateWeightLoss(weightKg, targetWeightKg, maxGoalPace, 5)
        : this.calculateWeightLoss(weightLbs, targetWeightLbs, maxGoalPace, 11)
    },

    getCurrentMonthLabel() {
      const today = new Date()
      return getCompactLocalizedDateLabel(today)
    },

    getGoalMonthLabel() {
      const isMetric = this.store.isMetric()
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs, goalPaceKg, goalPaceLbs } =
        this.store.values

      const daysTillGoalDate = getDaysTillGoalDate(
        {
          weightKg,
          weightLbs,
          targetWeightKg,
          targetWeightLbs,
          goalPaceKg,
          goalPaceLbs,
        },
        isMetric,
      )

      const minusDays = getFasterProgressDaysDiff(this.store.values, isMetric)
      const goalDate = new Date()
      const daysCount = daysTillGoalDate - minusDays > 0

      if (daysCount) {
        goalDate.setDate(goalDate.getDate() + daysTillGoalDate - minusDays)
      } else {
        goalDate.setDate(goalDate.getDate() + daysTillGoalDate)
      }

      return getCompactLocalizedDateLabel(goalDate)
    },

    getBmi() {
      const isMetric = this.store.isMetric()
      return getBmi(this.store.values, isMetric).toFixed(0)
    },

    getTargetBmi() {
      const { heightCm, heightFt, heightIn, targetWeightKg, targetWeightLbs } = this.store.values

      const values = {
        heightCm,
        heightFt,
        heightIn,
        weightKg: targetWeightKg,
        weightLbs: targetWeightLbs,
      }

      const isMetric = this.store.isMetric()
      return getBmi(values, isMetric).toFixed(0)
    },

    getBmiWidgetPointPosition() {
      const bmi = this.getBmi()

      const scaleMin = 15
      const scaleMax = 35

      if (bmi <= scaleMin) return 0
      if (bmi >= scaleMax) return 100

      return ((bmi - scaleMin) * 100) / (scaleMax - scaleMin)
    },

    getFirstWeekLoss() {
      return getFirstWeekLoss({
        values: this.store.values,
        isMetric: this.store.isMetric()
      })
    },

    getAgeDecade() {
      const age = (this.store.values.age)?.toString()

      return `${age[0]}0`
    },

    goNextAndTrack(clickName = "Continue Clicked") {
      this.store.internalTracker.setEventToSessionStorage({ clickName })
      this.goNext()
    },
  })
